export default {
  data () {
    return {
      locationInterval: '',
      locationIntervalDuration: 60000
    }
  },
  computed: {},
  methods: {
    checkAndSaveLocationData () {
      let self = this
      let locationIntervalDuration = +process.env.VUE_APP_LOCATION_INTERVAL || this.locationIntervalDuration
      console.log('Getting geolocation Data')
      this.locationInterval = setInterval(function () {
        if (self.isLogin) self.getLocation()
      }, locationIntervalDuration)
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.saveLocation)
      } else {
        console.log('Geolocation is not supported by this browser.')
        this.showAlert(4, 'Geolocation is not supported by this browser.')
      }
    },
    saveLocation (position) {
      let coords = position.coords
      if (!coords || !coords.latitude || !coords.longitude) return
      let locationObject = {
        lat: coords.latitude,
        lng: coords.longitude,
        time: Math.round(position.timestamp / 1000)
      }
      this.sendLocationDataToServer(locationObject)
      this.$store.commit('saveLocation', locationObject)
    },
    errorLocation (msg) {
      console.log(msg)
    },
    sendLocationDataToServer (locationObject) {
      this.$store.dispatch('sendLocationToServer', locationObject)
        .then(response => {
          console.log('Location data to the server has been sent')
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  beforeDestroy () {
    console.log('before destroy')
    clearInterval(this.locationInterval)
  }
}
